import { Review, ApiResult } from '../../../types';
import { api } from '../../d1';
import { ReviewMapper } from '../mappers/review.mapper';

export class D1ReviewsRepo {
    async getReviewsForListing(listingId: string): Promise<Review[]> {
        try {
            const rows = await api.reviews.list(listingId);
            return rows.map((r: any) => ReviewMapper.toDomain(r));
        } catch { return []; }
    }

    async getMyReviewForListing(userId: string, listingId: string): Promise<Review | null> {
        try {
            const reviews = await this.getReviewsForListing(listingId);
            return reviews.find(r => r.userId === userId) || null;
        } catch { return null; }
    }

    async createReview(params: Omit<Review, 'id' | 'createdAt'>): Promise<ApiResult<Review>> {
        try {
            const reviewId = crypto.randomUUID();
            const createdAt = new Date().toISOString();
            const payload = ReviewMapper.toRow({ ...params, id: reviewId, createdAt });
            await api.reviews.create(payload);
            const newReview: Review = {
                ...params,
                id: reviewId,
                createdAt: createdAt
            };
            return { success: true, data: newReview };
        } catch (e: any) {
            return { success: false, error: e.message };
        }
    }
}
